import { clsx } from 'clsx'

const SEVERITY_COLORS = {
  0: { bar: 'bg-emerald-400', text: 'text-emerald-400', label: 'Clear' },
  1: { bar: 'bg-cyan-400', text: 'text-cyan-400', label: 'Minor' },
  2: { bar: 'bg-amber-400', text: 'text-amber-400', label: 'Moderate' },
  3: { bar: 'bg-orange-400', text: 'text-orange-400', label: 'Significant' },
  4: { bar: 'bg-red-500', text: 'text-red-400', label: 'Severe' },
  5: { bar: 'bg-violet-500', text: 'text-violet-400', label: 'Extreme' },
}

export default function SeverityBar({ severity, showLabel = true, showNumber = true, compact = false }) {
  const level = Math.min(5, Math.max(0, Math.round(severity ?? 0)))
  const config = SEVERITY_COLORS[level] ?? SEVERITY_COLORS[0]
  const pct = (level / 5) * 100

  if (compact) {
    return (
      <span
        className={clsx(
          'inline-flex items-center justify-center rounded-full text-xs font-bold w-6 h-6',
          level === 0 && 'bg-emerald-500/20 text-emerald-400',
          level === 1 && 'bg-cyan-500/20 text-cyan-400',
          level === 2 && 'bg-amber-500/20 text-amber-400',
          level === 3 && 'bg-orange-500/20 text-orange-400',
          level === 4 && 'bg-red-500/20 text-red-400',
          level === 5 && 'bg-violet-500/20 text-violet-400',
        )}
      >
        {level}
      </span>
    )
  }

  return (
    <div className="flex items-center gap-2">
      {showNumber && (
        <span className={clsx('text-sm font-bold tabular-nums min-w-[1.5rem]', config.text)}>
          {level}
        </span>
      )}
      <div className="flex-1 h-2 bg-white/10 rounded-full overflow-hidden min-w-[60px]">
        <div
          className={clsx('h-full rounded-full transition-all duration-700', config.bar)}
          style={{ width: `${pct}%` }}
        />
      </div>
      {showLabel && (
        <span className={clsx('text-xs font-medium min-w-[5rem]', config.text)}>
          {config.label}
        </span>
      )}
    </div>
  )
}
